

import { format, addHours, parse, differenceInYears, isValid } from 'date-fns';
import { ru } from 'date-fns/locale';

export const getMoscowDate = (): string => {
  const now = new Date();
  const moscowTime = addHours(now, 3);
  return format(moscowTime, "yyyy-MM-dd'T'HH:mm:ss", { locale: ru });
};

export const finishTimeToMoscowIso = (startTime: Date | string): string => {
  const startDate = typeof startTime === 'string' ? new Date(startTime) : startTime;
  const finishDate = addHours(startDate, 1);
  const moscowTime = addHours(finishDate, 3); // UTC+3
  return format(moscowTime, "yyyy-MM-dd'T'HH:mm:ss", { locale: ru });
};

export const validateDateNotFuture = (dateString: string): { isValid: boolean; error?: string } => {
  if (!dateString || dateString.trim() === '') {
    return { isValid: false, error: 'Дата рождения обязательна для заполнения' };
  }

  const normalizedDate = dateString.replace(/\./g, '-');
  const dateParts = normalizedDate.split('-');
  
  if (dateParts.length !== 3) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10);
  const year = parseInt(dateParts[2], 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const date = parse(normalizedDate, 'dd-MM-yyyy', new Date());
  
  if (!isValid(date)) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  if (date > today) {
    return { isValid: false, error: 'Дата рождения не может быть в будущем' };
  }

  return { isValid: true };
};

export const validateChildAge = (dateString: string): { isValid: boolean; error?: string; age?: number } => {
  if (!dateString || dateString.trim() === '') {
    return { isValid: false, error: 'Дата рождения обязательна для заполнения' };
  }

  const normalizedDate = dateString.replace(/\./g, '-');
  const dateParts = normalizedDate.split('-');
  
  if (dateParts.length !== 3) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10);
  const year = parseInt(dateParts[2], 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const birthDate = parse(normalizedDate, 'dd-MM-yyyy', new Date());
  
  if (!isValid(birthDate)) {
    return { isValid: false, error: 'Неверный формат даты' };
  }

  const today = new Date();
  const age = differenceInYears(today, birthDate);

  if (age < 1) {
    return { isValid: false, error: 'Возраст ребенка должен быть больше 1 лет', age };
  }

  if (age > 13) {
    return { isValid: false, error: 'Возраст ребенка не должен превышать 13 лет', age };
  }

  return { isValid: true, age };
};

export const validateChildBirthDate = (dateString: string): { isValid: boolean; error?: string; age?: number } => {
  if (!dateString || dateString.trim() === '') {
    return { isValid: false, error: 'Дата рождения обязательна для заполнения' };
  }

  const dateValidation = validateDateNotFuture(dateString);
  if (!dateValidation.isValid) {
    return dateValidation;
  }

  const ageValidation = validateChildAge(dateString);
  if (!ageValidation.isValid) {
    return ageValidation;
  }

  return { isValid: true, age: ageValidation.age };
};

export const formatDateToISO = (dateString: string): string => {
  const normalizedDate = dateString.replace(/\./g, "-");
  const date = parse(normalizedDate, "dd-MM-yyyy", new Date());
  return format(date, "yyyy-MM-dd");
};

export const formatDateToISOWithTime = (dateString: string): string => {
  const normalizedDate = dateString.replace(/\./g, "-");
  const date = parse(normalizedDate, "dd-MM-yyyy", new Date());
  return format(date, "yyyy-MM-dd'T'HH:mm:ss");
};

